import { CollapseState } from 'ia-react-core/~/interfaces/CollapseState';
import { CoreAction } from 'ia-react-core/~/interfaces/CoreAction';
import openAllCollapses from 'ia-react-core/~/actions/collapse-fn/openAllCollapses';
import get from '../../../utils/accessors/get';
import set from '../../../utils/accessors/set';

import openCollapseById from '../../../actions/collapse-fn/openCollapseById';
import closeCollapseById from '../../../actions/collapse-fn/closeCollapseById';
import closeAllCollapses from '../../../actions/collapse-fn/closeAllCollapses';
import openCollapseByName from '../../../actions/collapse-fn/openCollapseByName';
import closeCollapseByName from '../../../actions/collapse-fn/closeCollapseByName';

export default function collapseReducer(state: CollapseState, action: CoreAction) {
  const collapseId = get(state, 'collapseId');
  const name = get(state, 'name');

  switch (action.type) {
    case `${openCollapseById.type}/${collapseId}`:
      return reduceOpenCollapse(state);
    case `${closeCollapseById.type}/${collapseId}`:
      return reduceCloseCollapse(state);
    case `${openCollapseByName.type}/${name}`:
      return reduceOpenCollapse(state);
    case `${closeCollapseByName.type}/${name}`:
      return reduceCloseCollapse(state);
    case openAllCollapses.type:
      return reduceOpenCollapse(state);
    case closeAllCollapses.type:
      return reduceCloseCollapse(state);
    default:
      return state;
  }
}

function reduceOpenCollapse(state: CollapseState): CollapseState {
  return set(state, 'isOpened', true);
}

function reduceCloseCollapse(state: CollapseState): CollapseState {
  return set(state, 'isOpened', false);
}
